import React, { useContext, useState } from 'react';
import { collection, query, where, getDocs, setDoc, getDoc, updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from '../firebase';
import { AuthContext } from '../context/AuthContext';

const Search = () => {
  const { currentUser } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [user, setUser] = useState(null);
  const [err, setErr] = useState(false);

  const handleSearch = async () => {
    if (!username) return;
    const q = query(collection(db, "users"), where("displayName", "==", username));

    try {
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        setErr(true);
        setUser(null);
      } else {
        querySnapshot.forEach((doc) => {
          setUser(doc.data());
        });
        setErr(false);
      }
    } catch (error) {
      console.error("Error searching user: ", error);
      setErr(true);
    }
  };

  const handleKey = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };

  const handleSelect = async () => {
    const combinedId = [currentUser.uid, user.uid].sort().join("");
    
    try {
      const res = await getDoc(doc(db, "chats", combinedId));
  
      if (!res.exists()) {
        await setDoc(doc(db, "chats", combinedId), { messages: [] });
      }
  
      await updateOrSetUserChat(currentUser.uid, combinedId, user);
      await updateOrSetUserChat(user.uid, combinedId, currentUser);
    } catch (error) {
      console.error("Error handling selection: ", error);
    }
    setUser(null);
    setUsername("");
  };

  const updateOrSetUserChat = async (userId, combinedId, otherUser) => {
    try {
      const userChatDocRef = doc(db, "userChats", userId);
      const userChatDoc = await getDoc(userChatDocRef);
      
      if (userChatDoc.exists()) {
        await updateDoc(userChatDocRef, {
          [combinedId]: {
            userInfo: {
              uid: otherUser.uid,
              displayName: otherUser.displayName,
              photoURL: otherUser.photoURL,
            },
            date: serverTimestamp(),
          },
        });
      } else {
        await setDoc(userChatDocRef, {
          [combinedId]: {
            userInfo: {
              uid: otherUser.uid,
              displayName: otherUser.displayName,
              photoURL: otherUser.photoURL,
            },
            date: serverTimestamp(),
          },
        });
      }
    } catch (error) {
      console.error("Error updating userChats: ", error);
    }
  };

  return (
    <div className='chat-search'>
      <div className="chat-search__container">
        <span className="chat-search__icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <input
          type="text"
          className="chat-search__input"
          placeholder='Search...'
          onKeyDown={handleKey}
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <span className="chat-search__shortcut">⌘K</span>
      </div>

      {err && <span className="chat-search__error">User not found</span>}
      {user && (
        <div className="chat-search__result" onClick={handleSelect}>
          <img src={user.photoURL} alt='' className="chat-search__result-avatar" />
          <div className="chat-search__result-info">
            <span className='chat-search__result-name'>{user.displayName}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Search;